import { downloadCSV } from '../csv';

/**
 * Generate a basic html table
 * @param {String[]} columnNames - array of strings representing the column names
 * @param {Array[]} rows - contents of the row. If an item is an array, each item will be stacked to fit into the table row cell.
 *                         Otherwise the value will be rendered as a string
 */
export const generateTable = (columnNames, rows) => {
  const tableHeader = columnNames.map(columnName => `<th>${columnName.toString()}</th>`).join('');
  const tableRows = rows.map(row =>
    `<tr>
      ${row.map(value => {
    if (Array.isArray(value)) {
      const tableCell = value.map(v => `<p>${v.toString()}</p>`).join('');
      return `<td>${tableCell}</td>`;
    } else {
      return `<td><p>${value.toString()}</p></td>`;
    }
  }).join('')}
    </tr>`
  ).join('');

  return `
    <table>
      <tr>
        ${tableHeader}
      </tr>
      ${tableRows}
    </table>
  `;
};

/**
 * Generate a basic html table as a string
 *
 * @returns {String}
 */
export const generatePrintableTable = (table) => {
  return `
    <html>
      <head>
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr, p {
            font-size: 10px;
          }

          @media print {
            @page {
              size: landscape;
            }
          }
        </style>
      </head>
      <body>
        ${table}
      </body>
    </html>
  `;
};

/**
 * example `rows` value:
 * [
 *  ['A', 'B', 'C'],
 *  ['1', '2', '3'],
 *  ['A', ['1', '2,'], ['C', 'D']]
 * ]
 */

/**
* Convert a table into csv
* @param {HTML} table - html table
* @param {String} filename
*/
export const exportTableToCSV = (table, filename) => {
  let csv = [];
  const rows = table.querySelectorAll('table tr');

  for (let i = 0; i < rows.length; i++) {
    const cols = rows[i].querySelectorAll('td, th');
    let row = [];

    for (let j = 0; j < cols.length; j++) {
      const node = cols[j];
      // header tags won't have any paragraph tags so we can just fetch their text content
      if (node.nodeName === 'TH') {
        row.push(node.innerText);
      } else if (node.nodeName === 'TD') {
        // a cell may have more than one shift so we have to get the p tags for each shift
        const columnContent = node.querySelectorAll('p');
        // get the contents of each tag
        const textArray = Array.from(columnContent).map(paragraph => paragraph.innerText);
        // in order for to each a multiline in a csv cell, the contents must be wrapped in double quotation marks with their newline character
        // const formatted = textArray.reduce((previousValue, currentValue, index) => {
        //   return index === 0 ? `${currentValue}` : `"${previousValue}\r${currentValue}"`;
        // }, '');
        const formatted = `"${textArray.join('\r')}"`;

        row.push(formatted);
      }
    }

    csv.push(row.join(','));
  }

  csv = csv.join('\n');

  downloadCSV(csv, filename);
};
